import { TEDCustomNumberParser } from './TEDCustomNumberParser';
import { TEDParseNumberMode } from '../FormatterTypes';

export class TEDParsePercent extends TEDCustomNumberParser {
  public static getInstance(): TEDParsePercent {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDParsePercent;

  mode(): TEDParseNumberMode {
    return TEDParseNumberMode.pnmPercent;
  }
}
